'use client'
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation';
import { loginClient } from '@/client/formClientActions';
import { loginInput } from '@/utils';
import { CommonInput } from '@/components';
import { useFormState, useFormStatus } from 'react-dom';
import { toast } from 'sonner';
import CustomButton from '@/components/common/CustomButton';
import Link from 'next/link';
import SeePasswordButton from '@/components/common/SeePasswordButton';

const LoginForm = () => {

  const initialState = { status: '', message: '' };
  const router = useRouter()
  const [data, formAction] = useFormState(loginClient, initialState);
  const isLocal = process.env.NODE_ENV === "development";

  // State to manage the submit button loading state
  useEffect(() => {
    if (data.status !== '') {
      if (data.status === 201) {
        toast.success(data.message)
        router.push(isLocal ? '/' : 'https://app.marinebroker.com.ar')
      } else toast.error(data.message)
    }
  }, [data])

  const [seePassword, setSeePassword] = useState(false);

  return (
    <form action={formAction} className='flex flex-col w-full gap-y-6'>
      <CommonInput {...loginInput} />
      <label className="flex flex-col justify-center w-full relative">
        <span className={`text-xs 2xl:text-sm font-semibold flex justify-between w-full`}>Contraseña</span>
        <input
          type={seePassword ? 'text' : 'password'}
          name='password'
          required={true}
          minLength={8}
          maxLength={25}
          placeholder='*********'
          className='w-full h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
        <SeePasswordButton seePassword={seePassword} setSeePassword={setSeePassword} />
      </label>
      <div className='w-full flex items-center justify-between'>
        <div className='flex items-center'>
          <input defaultChecked type="checkbox" name='remember' />
          <p className='text-sm text-gray-500 ml-1'>Recordarme</p>
        </div>
        <Link href='/auth/recover-password' className='text-primary text-sm font-bold underline underline-offset-4 tracking-wide'>¿Olvidaste tu contraseña?</Link> 
      </div>
      <LoginButton />
    </form>
  )
}

function LoginButton() {
  const { pending } = useFormStatus()
  return (
    <div>
      <CustomButton type='submit' disabled={pending} title={pending ? 'Iniciando...' : 'Inciar sesión'} colorType={pending ? 'disabled' : 'primary'} />
    </div>
  )
}

export default LoginForm